// Rich text saved from the dashboard editor is usually pasted in from Word or
// Google Docs, which use &nbsp; in place of ordinary word spacing. A paragraph
// joined by them is one unbreakable word, so the browser has nowhere legal to
// wrap and splits it mid-letter instead. Turn lone ones back into real spaces;
// runs of two or more are deliberate indentation, so leave those alone.
export const normalizeRichText = (html) => {
  if (typeof html !== "string") return html;
  return html
    .replace(/&nbsp;|&#160;|&#xA0;/gi, "\u00a0")
    .replace(/\u00a0+/g, (run) => (run.length === 1 ? " " : run));
};
